import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  },
);

// API endpoints
export const servicesApi = {
  getAll: (active?: boolean) => api.get('/services', { params: { active } }),
  getBySlug: (slug: string) => api.get(`/services/${slug}`),
  getImages: (slug: string) => api.get(`/services/${slug}/images`),
};

export const contactsApi = {
  create: (data: any) => api.post('/contacts', data),
};

export const pagesApi = {
  getBySlug: (slug: string) => api.get(`/pages/${slug}`),
};

export const blogApi = {
  getAll: (published?: boolean) => api.get('/blog', { params: { published } }),
  getBySlug: (slug: string) => api.get(`/blog/${slug}`),
};

export const settingsApi = {
  getPublic: () => api.get('/settings'),
};

export const homepageApi = {
  getSections: () => api.get('/homepage/sections'),
  getSectionByKey: (key: string) => api.get(`/homepage/sections/${key}`),
};

export const footerApi = {
  getContents: () => api.get('/footer/contents'),
  getContentBySection: (section: string) => api.get(`/footer/contents/${section}`),
};

export const authApi = {
  login: (email: string, password: string) =>
    api.post('/auth/login', { email, password }),
  refresh: (refreshToken: string) =>
    api.post('/auth/refresh', { refreshToken }),
  logout: () => api.post('/auth/logout'),
  me: () => api.get('/auth/me'),
};

export const whatsappApi = {
  sendMessage: (data: { phoneNumber: string; message: string }) =>
    api.post('/whatsapp/send', data),
};

